import Vue from 'vue';
import './plugins/axios';
import App from './App.vue';
import router from './router';
import store from './store';
import '@babel/polyfill';
import 'es6-promise/auto';
import vueMoment from 'vue-moment';
import VueMonthlyPicker from 'vue-monthly-picker';
import { VTooltip, VPopover, VClosePopover } from 'v-tooltip';
import ResellerButton from './components/Button.vue';

Vue.config.productionTip = false;

Vue.use(vueMoment);

Vue.component('ResellerButton', ResellerButton);
Vue.component('VueMonthlyPicker', VueMonthlyPicker);

Vue.directive('tooltip', VTooltip);
Vue.directive('close-popover', VClosePopover);
Vue.component('v-popover', VPopover);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
